<div ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl" class="title-wrapper" fxLayout="row" fxLayoutAlign="center center">
    <div fxFlex.gt-sm="70" fxFlex.sm="90" fxFlex.xs="95">
        <h1 ngClass.sm="sm" class="title-h1">{{ title }}</h1>
    </div>
</div>
